import HttpService from './http.service';

class LocationService {
  suggestLocations(params) {
    return HttpService.get('locations/suggestions', {
      params,
    })
      .then((res) => res.data);
  }

  getLocations(params) {
    return HttpService.get('locations', {
      params,
    })
      .then((res) => res.data);
  }

  getLocation(id) {
    return HttpService.get(`locations/${id}`)
      .then((res) => res.data);
  }

  createLocation(location) {
    return HttpService.post('locations', location)
      .then((res) => res.data);
  }

  updateLocation(location) {
    return HttpService.patch(`locations/${location.id}`, location)
      .then((res) => res.data);
  }

  deleteLocation(location) {
    return HttpService.delete(`locations/${location.id}`)
      .then((res) => res.data);
  }

  getSubLocations(params) {
    return HttpService.get('sub_locations', {
      params,
    })
      .then((res) => res.data);
  }

  getSubLocation(id) {
    return HttpService.get(`sub_locations/${id}`)
      .then((res) => res.data);
  }

  createSubLocation(subLocation) {
    return HttpService.post('sub_locations', subLocation)
      .then((res) => res.data);
  }

  updateSubLocation(subLocation) {
    return HttpService.patch(`sub_locations/${subLocation.id}`, subLocation)
      .then((res) => res.data);
  }

  deleteSubLocation(subLocation) {
    return HttpService.delete(`sub_locations/${subLocation.id}`)
      .then((res) => res.data);
  }
}

export default new LocationService();
